import React from 'react';

import Icon from 'components/Icon';

const menu = {
  dashboard: {
    label: 'Dashboard',
    to: '/dashboard',
    icon: <Icon name='grid' size={16} />,
  },
  monitor: {
    label: 'Monitor',
    to: '/monitor',
    icon: <Icon name="monitor" size={16} />,
  },
  alerts: {
    label: 'Alerts',
    to: '/alerts',
    icon: <Icon name='bell' size={16} />,
  },
  unloads: {
    type: 'item',
    label: 'Inbound',
    icon: <Icon name='package' size={16} />,
    to: '/unloads',
  },
  loads: {
    type: 'item',
    label: 'Outbound',
    icon: <Icon name='share-2' size={16} />,
    to: '/loads',
  },
  individuals: {
    type: 'sub',
    label: 'Individuals',
    icon: <Icon name='users' size={16} />,
    items: {
      checked: {
        type: 'item',
        label: 'Checked-in',
        to: '/individuals/registered',
      },
      live: {
        type: 'item',
        label: 'Active',
        to: '/individuals/active',
      },
      stats: {
        type: 'item',
        label: 'Statistics',
        to: '/individuals',
      },
    },
  },
  carts: {
    type: 'sub',
    label: 'Carts',
    icon: <Icon name="shopping-cart" size={16} />,
    items: {
      flow: {
        type: 'item',
        label: 'Flow',
        to: '/carts/flow',
      },
      stats: {
        type: 'item',
        label: 'Stats',
        to: '/carts/stats',
      }
    }
  },
  dcMap: {
    type: 'item',
    label: 'Map View',
    icon: <Icon name="map-pin" size={16} />,
    to: '/map',
  },
  reports: {
    type: 'item',
    label: 'Reports',
    icon: <Icon name="file-text" size={16} />,
    to: '/reports',
  },
  admin: {
    type: 'section',
    label: 'Administration',
    items: {
      users: {
        type: 'item',
        label: 'Users',
        to: '/users',
        icon: <Icon name='user' size={16} />,
      },
      locations: {
        type: 'item',
        label: 'Locations',
        to: '/locations',
        icon: <Icon name='map-pin' size={16} />,
      },
      doors: {
        type: 'item',
        key: 'doors',
        label: 'Doors',
        to: '/doors',
        icon: <Icon name='airplay' size={16} />,
      },
      servers: {
        type: 'item',
        key: 'servers',
        label: 'Servers',
        to: '/servers',
        icon: <Icon name="cpu" size={16} />,
        disabled: false,
      },
      cameras: {
        type: 'item',
        key: 'cameras',
        label: 'Cameras',
        to: '/cameras',
        icon: <Icon name="video" size={16} />,
        disabled: false
      },
      btc: {
        type: 'item',
        key: 'btc',
        label: 'BTCs',
        to: '/btc',
        icon: <Icon name="clock" size={16} />,
        disabled: false
      },
      employees: {
        type: 'item',
        key: 'employees',
        label: 'Employees',
        to: '/employees',
        icon: <Icon name='users' size={16} />,
        disabled: false,
      },
      agencies: {
        type: 'item',
        key: 'agencies',
        label: 'Agencies',
        to: '/agencies',
        icon: <Icon name="briefcase" size={16} />,
        disabled: false,
      },
      featureFlags: {
        type: 'item',
        key: 'featureFlags',
        label: 'Feature Flags',
        to: '/featureFlags',
        icon: <Icon name="check-square" size={16} />,
        disabled: false,
      }
    },
  },
  account: {
    type: 'section',
    align: 'bottom',
    label: 'Your Account',
    items: {
      settings: {
        type: 'item',
        label: 'Settings',
        to: '/settings',
        icon: <Icon name='settings' size={16} />,
        // disabled: true,
      },
      logout: {
        type: 'item',
        label: 'Logout',
        to: '/logout',
        icon: <Icon name='log-out' size={16} />,
      },
    },
  },
};

export default menu;
